// src/components/BookingList.js

import React from 'react';
import { List } from '@mui/material';
import BookingItem from './BookingItem';
import PropTypes from 'prop-types';

const BookingList = ({ bookings, role }) => {
    return (
        <List>
            {bookings.map((booking) => (
                <BookingItem key={booking.id} booking={booking} role={role} />
            ))}
        </List>
    );
};

BookingList.propTypes = {
    bookings: PropTypes.array.isRequired,
    role: PropTypes.oneOf(['borrower', 'lender']).isRequired,
};

export default BookingList;
